// B1.4: audit domain methods (move-only from client.ts).
import { ApiClientCore, buildQueryString } from './http/core';

export class AuditApi extends ApiClientCore {
  // ─── Audit / 152-FZ ────────────────────────────────────────────────────────
  async getAuditLogs(params: Record<string, any> = {}): Promise<any> {
    return this.get(`/api/v1/audit/logs${buildQueryString(params)}`);
  }
  async getAuditEntityHistory(entityType: string, entityId: number, limit?: number): Promise<{
    entity_type: string;
    entity_id: number;
    history: any[];
  }> {
    return this.get(`/api/v1/audit-logs/entity/${entityType}/${entityId}${buildQueryString({ limit })}`);
  }
  async getAuditEntityTypes(): Promise<{ value: string; label: string }[]> {
    return this.get('/api/v1/audit-logs/entity-types');
  }
  async getAuditStats(params: Record<string, any> = {}): Promise<any> {
    return this.get(`/api/v1/audit/stats${buildQueryString(params)}`);
  }
}
